import config from "../../config";
import {CustomerWithSession} from "./customer";
import {CustomerServiceError} from "./error";
import {getDeviceHeader} from "./device-header";

export class RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  countryCode: string;
  postalCode: string;
  shareId: string;
  fromCampaign: { [key: string]: string };
  cardNumber: string;
  optInEmailAdvertisementConsent: boolean;
  optInEmailChannelNewsletter: boolean;
  optInEmailChannelLoyalty: boolean;
  optInEmailChannelWomensFashion: boolean;
  optInEmailChannelMensFashion: boolean;
}


export async function registerCustomer(registerData: RegisterData): Promise<CustomerWithSession> {
  const result = await fetch(`${config.customerServiceUrl}/customer/register`, {
    body: JSON.stringify(registerData),
    cache: 'no-cache',
    headers: {
      'content-type': 'application/json',
      'NY-DEVICE-DATA': getDeviceHeader(),
    },
    method: 'POST',
  });

  const json = await result.json();
  if (json.error) {
    throw new CustomerServiceError(json);
  }

  if (!result.ok) {
    throw new CustomerServiceError(json);
  }

  return new CustomerWithSession(json);
}
